import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from "../../config";


const Field = ({ label, children }) => (
  <div className="row mb-3 align-items-center">
    <div className="col-md-4 fw-bold text-secondary">{label}</div>
    <div className="col-md-8">{children}</div>
  </div>
);

const SectionHeader = ({ title }) => (
  <div 
    className="p-2 mb-3 mt-4 rounded shadow-sm d-flex align-items-center" 
    style={{ 
      color: "black", 
      height: "45px",
    }}
  >
    <h6 className="mb-0 fw-bold text-uppercase" style={{ letterSpacing: '1px' }}>{title}</h6>
  </div>
);

const CamVisibilityPage = (props) => {
  // ================= VEHICLE =================
  const [vehicleType, setVehicleType] = useState("");
  const [routeFrom, setRouteFrom] = useState("");
  const [routeTo, setRouteTo] = useState("");

  // ================= INCOME =================
  const [collectionPerTrip, setCollectionPerTrip] = useState("");
  const [tripsPerDay, setTripsPerDay] = useState("");
  const [daysPerMonth, setDaysPerMonth] = useState("");

  const earningsPerDay =
    Number(collectionPerTrip || 0) * Number(tripsPerDay || 0);

  const earningsPerMonth =
    earningsPerDay * Number(daysPerMonth || 0);

  // ================= EXPENSE =================
  const [tyreCost, setTyreCost] = useState("");
  const [electricityCost, setElectricityCost] = useState("");
  const [maintenance, setMaintenance] = useState("");
  const [driverSalary, setDriverSalary] = useState("");
  const [insurance, setInsurance] = useState("");
  const [misc, setMisc] = useState("");

  const expensesPerMonth =
    Number(tyreCost || 0) +
    Number(electricityCost || 0) +
    Number(maintenance || 0) +
    Number(driverSalary || 0) +
    Number(insurance || 0) +
    Number(misc || 0);

  const grossInflow = earningsPerMonth - expensesPerMonth;

  // ================= CAM =================
  const [incomeOther, setIncomeOther] = useState("");
  const [emiExisting, setEmiExisting] = useState("");
  const [emiProposed, setEmiProposed] = useState("");
  const [household, setHousehold] = useState("");
  const [historyList, setHistoryList] = useState([]);
  const [usersMap, setUsersMap] = useState({});

  const totalIncome = grossInflow + Number(incomeOther || 0);

  const totalFixed =
    Number(emiExisting || 0) + Number(emiProposed || 0);

  const totalExpense = totalFixed + Number(household || 0);

  const disposable = totalIncome - totalExpense;

  const foir =
    totalIncome > 0
      ? ((totalFixed / totalIncome) * 100).toFixed(2)
      : 0;

  const etoi =
    totalIncome > 0
      ? ((totalExpense / totalIncome) * 100).toFixed(2)
      : 0;

  const [loading, setLoading] = useState(false);
  const [submittedInfo, setSubmittedInfo] = useState(null);

  // ================= FETCH & PREFILL =================
const fetchVisibilityData = async () => {
  const leadId =
    props?.leadInfo?.data?.[0]?.id ??
    props?.leadInfo?.id ??
    null;

  if (!leadId) return;

  try {
    const response = await fetch(
      `${config.API_BASE_URL}/get_visibility_sheet_by_lead/${leadId}`
    );

    const result = await response.json();

    if (result?.status === true && result?.data) {

      setHistoryList(result.data.list || []);

      const d = result.data.latest;

      if (d) {
        setVehicleType(d.vehicle_type ?? "");
        setRouteFrom(d.route_from ?? "");
        setRouteTo(d.route_to ?? "");
        setCollectionPerTrip(d.collection_per_trip ?? "");
        setTripsPerDay(d.trips_per_day ?? "");
        setDaysPerMonth(d.days_per_month ?? "");
        setTyreCost(d.tyre_cost ?? "");
        setElectricityCost(d.electricity_cost ?? "");
        setMaintenance(d.maintenance_cost ?? "");
        setDriverSalary(d.driver_salary ?? "");
        setInsurance(d.insurance_cost ?? "");
        setMisc(d.misc_cost ?? "");
        setIncomeOther(d.income_from_others ?? "");
        setEmiExisting(d.emi_existing ?? "");
        setEmiProposed(d.emi_proposed ?? "");
        setHousehold(d.household_expense ?? "");
      }
    }
  } catch (error) {
    console.error("Fetch visibility sheet error:", error);
  }
};

  useEffect(() => {
    fetchVisibilityData();
  }, [props?.leadInfo]);
  useEffect(() => {
  fetchUsers();
  fetchVisibilityData();
}, [props?.leadInfo]);

    const fetchUsers = async () => {
    try {
      const response = await fetch(
        `${config.API_BASE_URL}/fetch_user_name_id`
      );

      const result = await response.json();
      console.log(result);
      

      if (result?.status && Array.isArray(result?.data)) {
        const map = {};

        result.data.forEach((user) => {
          map[user.id] = user.name;
        });

        setUsersMap(map);
      }
    } catch (error) {
      console.error("User fetch error:", error);
    }
  };

  const handleSubmit = async () => {
  if (loading) return;

  // Validate all required fields
  const requiredFields = [
    { value: vehicleType, name: "Type of vehicle" },
    { value: routeFrom, name: "ROUTE (From)" },
    { value: routeTo, name: "ROUTE (To)" },
    { value: collectionPerTrip, name: "Collection per trip" },
    { value: tripsPerDay, name: "Number of Trips in a day" },
    { value: daysPerMonth, name: "Days/Month" },
    { value: tyreCost, name: "Tyre Cost" },
    { value: electricityCost, name: "Electricity Cost" },
    { value: maintenance, name: "Maintenance/month" },
    { value: driverSalary, name: "Driver" },
    { value: insurance, name: "Insurance" },
    { value: misc, name: "Miscellaneous" },
    { value: incomeOther, name: "Income from Others" },
    { value: emiExisting, name: "EMI of Existing loans" },
    { value: emiProposed, name: "EMI of Proposed loan" },
    { value: household, name: "Household and other personal Expenses" },
  ];

  const emptyFields = requiredFields.filter((f) => f.value === "" || f.value === null || f.value === undefined);

  if (emptyFields.length > 0) {
    toast.error(`Please fill: ${emptyFields.map((f) => f.name).join(", ")}`, {
      position: "top-right",
    });
    return;
  }

  setLoading(true);

  try {
    const payload = {
      lead_id:
        props?.leadInfo?.data?.[0]?.id ??
        props?.leadInfo?.id ??
        null,

      user_id: props?.userInfo?.id ?? null,

      vehicle_type: vehicleType,
      route_from: routeFrom,
      route_to: routeTo,

      collection_per_trip: Number(collectionPerTrip || 0),
      trips_per_day: Number(tripsPerDay || 0),
      days_per_month: Number(daysPerMonth || 0),

      earnings_per_day: Number(earningsPerDay || 0),
      earnings_per_month: Number(earningsPerMonth || 0),

      tyre_cost: Number(tyreCost || 0),
      electricity_cost: Number(electricityCost || 0),
      maintenance_cost: Number(maintenance || 0),
      driver_salary: Number(driverSalary || 0),
      insurance_cost: Number(insurance || 0),
      misc_cost: Number(misc || 0),


      gross_inflow: Number(grossInflow || 0),

      income_from_others: Number(incomeOther || 0),
      total_income: Number(totalIncome || 0),

      emi_existing: Number(emiExisting || 0),
      emi_proposed: Number(emiProposed || 0),
      total_fixed_obligation: Number(totalFixed || 0),

      household_expense: Number(household || 0),
      total_expense: Number(totalExpense || 0),

      disposable_income: Number(disposable || 0),
      foir_percentage: Number(foir || 0),
      expense_to_income_percentage: Number(etoi || 0),
    };

    const response = await fetch(
      `${config.API_BASE_URL}/create_visible_spreadsheet`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const result = await response.json();

    console.log("API RESULT:", result);

    if (result?.status === true || result?.success === 1) {
      toast.success("Saved Successfully", {
        position: "top-right",
      });
      // Set submitted by info
      setSubmittedInfo({
        name: props?.userInfo?.name ?? "Unknown",
        time: new Date().toLocaleString("en-IN", {
          dateStyle: "medium",
          timeStyle: "short",
        }),
      });
      // Re-fetch latest data to keep form filled
      await fetchVisibilityData();
    } else {
      toast.error(result?.message || "Something went wrong", {
        position: "top-right",
      });
    }

  } catch (error) {
    console.error("API ERROR:", error);
    toast.error(error.message, {
      position: "top-right",
    });
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="container-fluid p-3">

      {/* ================= VEHICLE ================= */}
      <SectionHeader title="Vehicle Details" />

      <Field label="Type of vehicle (Passenger / cargo)">
        <select
          className="form-control"
          value={vehicleType}
          onChange={(e) => setVehicleType(e.target.value)}
        >
          <option value="">Select</option>
          <option>Passenger</option>
          <option>Cargo</option>
        </select>
      </Field>

      <Field label="ROUTE (From)">
        <input
          className="form-control"
          value={routeFrom}
          onChange={(e) => setRouteFrom(e.target.value)}
        />
      </Field>

      <Field label="ROUTE (To)">
        <input
          className="form-control"
          value={routeTo}
          onChange={(e) => setRouteTo(e.target.value)}
        />
      </Field>

    

      {/* ================= INCOME ================= */}
      <SectionHeader title="Particular - Amount" />
        <div className="row mb-2">
        <div className="col-12">
          <div
            className="fw-bold text-uppercase shadow-sm d-flex align-items-center"
            style={{
              color: "black",
              letterSpacing: "1px",
              height: "32px",
              padding: "0 10px",
              fontSize: "17px",
            }}
          >
            Income
          </div>
        </div>
      </div>

      <Field label="Collection per trip">
        <input
          className="form-control"
          type="number"
          min="0"
          value={collectionPerTrip}
          onChange={(e) => setCollectionPerTrip(e.target.value)}
          onKeyDown={(e) => ["-", "e", "E"].includes(e.key) && e.preventDefault()}
        />
      </Field>

      <Field label="Number of Trips in a day">
        <input
          className="form-control"
          type="number"
          min="0"
          value={tripsPerDay}
          onChange={(e) => setTripsPerDay(e.target.value)}
          onKeyDown={(e) => ["-", "e", "E"].includes(e.key) && e.preventDefault()}
        />
      </Field>

      <Field label="Earnings Per Day">
        <input className="form-control bg-light" value={earningsPerDay} readOnly />
      </Field>

      <Field label="Days/Month">
        <input
          className="form-control"
          type="number"
          min="0"
          value={daysPerMonth}
          onChange={(e) => setDaysPerMonth(e.target.value)}
          onKeyDown={(e) => ["-", "e", "E"].includes(e.key) && e.preventDefault()}
        />
      </Field>

      <Field label="Earnings Per Month">
        <input className="form-control bg-light" value={earningsPerMonth} readOnly />
      </Field>

      {/* ================= EXPENSE ================= */}
      <SectionHeader title="Expenses" />

      <Field label="Tyre Cost">
        <input className="form-control" type="number" min="0" value={tyreCost} onChange={(e) => setTyreCost(e.target.value)} onKeyDown={(e) => ["-", "e", "E"].includes(e.key) && e.preventDefault()} />
      </Field>

      <Field label="Electricity Cost">
        <input className="form-control" type="number" min="0" value={electricityCost} onChange={(e) => setElectricityCost(e.target.value)} onKeyDown={(e) => ["-", "e", "E"].includes(e.key) && e.preventDefault()} />
      </Field>

      <Field label="Maintenance/month">
        <input className="form-control" type="number" min="0" value={maintenance} onChange={(e) => setMaintenance(e.target.value)} onKeyDown={(e) => ["-", "e", "E"].includes(e.key) && e.preventDefault()} />
      </Field>

      <Field label="Driver">
        <input className="form-control" type="number" min="0" value={driverSalary} onChange={(e) => setDriverSalary(e.target.value)} onKeyDown={(e) => ["-", "e", "E"].includes(e.key) && e.preventDefault()} />
      </Field>

      <Field label="Insurance">
        <input className="form-control" type="number" min="0" value={insurance} onChange={(e) => setInsurance(e.target.value)} onKeyDown={(e) => ["-", "e", "E"].includes(e.key) && e.preventDefault()} />
      </Field>

      <Field label="Miscellaneous">
        <input className="form-control" type="number" min="0" value={misc} onChange={(e) => setMisc(e.target.value)} onKeyDown={(e) => ["-", "e", "E"].includes(e.key) && e.preventDefault()} />
      </Field>

      <Field label="Expenses Per Month">
        <input className="form-control bg-light" value={expensesPerMonth} readOnly />
      </Field>
      

      {/* ================= CAM ================= */}
      <SectionHeader title="Credit Analysis Memorandum(CAM)" />

      <Field label="Income from Vehicle">
        <input className="form-control bg-light" value={grossInflow} readOnly />
      </Field>

      <Field label="Income from Others">
        <input className="form-control" type="number" min="0" value={incomeOther} onChange={(e) => setIncomeOther(e.target.value)} onKeyDown={(e) => ["-", "e", "E"].includes(e.key) && e.preventDefault()} />
      </Field>

      <Field label="Total Income">
        <input className="form-control bg-light" value={totalIncome} readOnly />
      </Field>

      <Field label="EMI of Existing loans">
        <input className="form-control" type="number" min="0" value={emiExisting} onChange={(e) => setEmiExisting(e.target.value)} onKeyDown={(e) => ["-", "e", "E"].includes(e.key) && e.preventDefault()} />
      </Field>

      <Field label="EMI of Proposed loan">
        <input className="form-control" type="number" min="0" value={emiProposed} onChange={(e) => setEmiProposed(e.target.value)} onKeyDown={(e) => ["-", "e", "E"].includes(e.key) && e.preventDefault()} />
      </Field>

      <Field label="Total Fixed Obligation">
        <input className="form-control bg-light" value={totalFixed} readOnly />
      </Field>

      <Field label="Household and other personal Expenses">
        <input className="form-control" type="number" min="0" value={household} onChange={(e) => setHousehold(e.target.value)} onKeyDown={(e) => ["-", "e", "E"].includes(e.key) && e.preventDefault()} />
      </Field>

      <Field label="Total Expense">
        <input className="form-control bg-light" value={totalExpense} readOnly />
      </Field>

      <Field label="Disposable Income (Total Income - Total Expenses)">
        <input className="form-control bg-light" value={disposable} readOnly />
      </Field>

      <Field label="FOIR (Total Fixed obligation/Total Income)">
        <input className="form-control bg-light" value={`${foir}%`} readOnly />
      </Field>

      <Field label="Expense to Income (Total Expense/Total Income)">
        <input className="form-control bg-light" value={`${etoi}%`} readOnly />
      </Field>

      <button 
        className="btn btn-primary mt-3" 
        onClick={handleSubmit}
        disabled={loading}
      >
        {loading ? "Saving..." : "Submit"}
      </button>

      {historyList.length > 0 ? (
              (() => {
                const latest = historyList[0]; // because API DESC order me aa rahi hai

                return (
                  <div
                    className="mt-3 p-3 rounded shadow-sm"
                    style={{
                      backgroundColor: "#e8f5e9",
                      border: "1px solid #a5d6a7",
                      color: "#2e7d32",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <i className="bi bi-check-circle-fill me-2" />
                        <strong>Submitted / Updated By:</strong>{" "}
                        {usersMap[latest.user_id] || latest.user_id}
                      </div>

                      <div>
                        <strong>On:</strong>{" "}
                        {new Date(latest.created_at).toLocaleString("en-IN", {
                          dateStyle: "medium",
                          timeStyle: "short",
                        })}
                      </div>
                    </div>
                  </div>
                );
              })()
            ) : (
              <div className="text-center mt-3 text-muted">
               &nbsp;
              </div>
            )}

      
    </div>
  );
};

function mapStateToProps(state) {
  return {
    userInfo: state.userInfo,
  };
}

export default connect(mapStateToProps)(CamVisibilityPage);